export var sizeMap = {
    default: '16',
    large: '24',
    tiny: '12',
};
